import { useMemo } from 'react'
import { SparklesIcon } from 'src/components/Icons/SparklesIcon'
import { getResponsiveVisibility } from 'src/utils/getResponsiveVisibility'
import { openShoppingMuse } from 'src/sdk/muse/openShoppingMuse'
import { useMuseEntryPointsConfig } from 'src/sdk/muse/useMuseEntryPointsConfig'

const DEFAULT_TITLE = 'Não encontrou o que procurava?'
const DEFAULT_SUBTITLE = 'Nosso assistente virtual pode te ajudar'
const DEFAULT_CTA = 'Falar com assistente virtual'

export function MusePlpEntryPoint() {
  const config = useMuseEntryPointsConfig()
  const plp = config?.plp

  const visibilityClasses = useMemo(() => {
    return getResponsiveVisibility(plp?.showOnDesktop, plp?.showOnMobile)
  }, [plp?.showOnDesktop, plp?.showOnMobile])

  if (!plp?.enableSession) {
    return null
  }

  return (
    <section
      data-testid="muse-plp-entry-point"
      data-dy-id="muse-plp-entry"
      className={`mx-md my-lg restructure-small-desktop:mx-auto restructure-small-desktop:max-w-[1280px] ${visibilityClasses}`}
    >
      <div className="flex flex-col items-center justify-center gap-md overflow-hidden rounded-lg border border-solid border-restructure-borderColor-primary bg-restructure-background-primary p-[18px] shadow-[0px_0px_12px_2px_rgba(37,52,221,0.12)]">
        <div className="flex w-full flex-col items-center gap-xxs">
          <div className="flex max-w-full items-center justify-center gap-xxs">
            <span className="inline-flex size-8 shrink-0 items-center justify-center text-restructure-action">
              <SparklesIcon color="currentColor" full className="size-8" />
            </span>
            <h2 className="dy-muse-widget-container-modal max-w-full text-center font-display font-semibold text-[26px] leading-[1.23] text-neutral11">
              {plp.title ?? DEFAULT_TITLE}
            </h2>
          </div>
          <p className="dy-muse-widget-container-modal w-full text-center text-font-size-2 font-medium text-neutral11">
            {plp.subtitle ?? DEFAULT_SUBTITLE}
          </p>
        </div>
        <button
          type="button"
          data-dy-id="muse-plp-cta"
          data-testid="muse-plp-cta"
          className="dy-chat-cta flex h-xxl min-h-xxl w-full min-w-10 items-center justify-center rounded-round bg-restructure-background-action-1 px-md py-xxs text-font-size-4 font-semibold text-restructure-white restructure-small-desktop:w-auto"
          onClick={openShoppingMuse}
        >
          {plp.ctaLabel ?? DEFAULT_CTA}
        </button>
      </div>
    </section>
  )
}
